<template>
    <div class="animated fadeIn master-form-page">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="master-back-wrapper">
                <b-button type="button" name="cabangBackBtn" @click="$router.go(-1)">
                    <i class="fa fa-angle-left mr-2"></i>Back
                </b-button>
            </div>
            <div class="master-form-card">
            <h5 class="master-page-title">Edit Cabang</h5>
            <b-form @submit.prevent="openModalConfirm" >
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA CABANG</h6>
                    <b-form-group label="Kode Cabang">
                        <b-form-input v-model="input.kodeCabang" name="kodeCabang" :state="kodeCabangState" :maxlength="4" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Nama Cabang">
                        <b-form-input v-model="input.namaCabang" name="namaCabang" type="text" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="No.Telp Cabang">
                        <b-form-input v-model="input.noTelpCabang" name="noTelpCabang"></b-form-input>
                    </b-form-group>
                    <LokasiCabang v-model="input.lokasi" style="grid-column: 1 / -1;" />
                    <b-form-group class="master-form-wide" label="Alamat Cabang">
                        <b-form-textarea v-model="input.alamatCabang" name="alamatCabang" rows="3" required></b-form-textarea>
                    </b-form-group>
                    <b-form-group label="Skema Perhitungan">
                        <b-form-select v-model="input.skemaPerhitungan" name="skemaPerhitungan" :options="skemaOption" value-field="id" text-field="name" required> 
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
					<b-form-group label="Latitude">
						<b-form-input v-model="input.latitude" max="15" name="latitude"></b-form-input>
						<span class="smallText text-muted">
							Latitude cabang (sebagai contoh, -82.28182)
						</span>
					</b-form-group>
					<b-form-group label="Longitude">
						<b-form-input v-model="input.longitude" max="15" name="longitude"></b-form-input>
						<span class="smallText text-muted">
							Longitude cabang (sebagai contoh, 12.99782)
						</span>
					</b-form-group>
					<b-form-group label="Alamat IP Cabang">
						<b-form-input v-model="input.ipAddress" max="20" name="ipAddress"></b-form-input>
						<span class="smallText text-muted">
							Alamat IP untuk WiFi pada cabang (Digunakan untuk pengecekan akses user). Contoh: 36.121.33.211
						</span>
					</b-form-group>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PIC</h6>
                    <b-form-group label="Kepala Unit">
                        <div class="d-flex">
                            <b-input-group>
                                <b-form-select v-if="kuLoading == true" v-model="data" name="kepalaUnit" disabled>
                                    <template v-slot:first>
                                        <b-form-select-option value="null" disabled>Mengambil data ...</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-form-select v-else v-model="input.kepalaUnit" name="kepalaUnit" :options="ku" value-field="id" text-field="name">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <b-input-group-append v-if="kuLoadingFail == true">
                                    <b-button variant="primary" size="sm" @click="loadKU"><i class="fa fa-refresh"></i></b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <b-button class="ml-2" variant="danger" name="removeKU" @click="onRemoveKU">Hapus</b-button>
                        </div>
                    </b-form-group>
                    <b-form-group label="Kepala Cabang">
                        <div class="d-flex">
                            <multiselect
                                name="kepalaCabang"
                                v-model="input.kepalaCabang" 
                                :options="staffKC" 
                                :internal-search="false"
                                :loading="isLoadingKC"
                                @search-change="searchKC"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="*Ketik min. 4 huruf untuk mencari..."
                            />
                            <b-button class="ml-2" variant="danger" name="removeKC" @click="onRemoveKC">Hapus</b-button>
                        </div>
                    </b-form-group>
                    <b-form-group label="Kepala Cabang Senior">
                        <div class="d-flex">
                            <multiselect
                                name="kepalaCabangSenior"
                                v-model="input.kepalaCabangSenior" 
                                :options="staffKCS" 
                                :internal-search="false"
                                :loading="isLoadingKCS"
                                @search-change="searchKCS"
                                :allow-empty="false"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="*Ketik min. 4 huruf untuk mencari..."
                            />
                            <b-button class="ml-2" variant="danger" name="removeKCS" @click="onRemoveKCS">Hapus</b-button>
                        </div>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="cabangSubmitBtn" variant="pgiBtn">Kirim</b-button>
                    <b-button type="button" name="cabangCancelBtn" @click="$router.go(-1)">Batal</b-button>
                </div>
            </b-form>
            </div>
        </div>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Cabang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah cabang ini?" @submit="onSubmit" />
    </div>
</template>

<script>
import LokasiCabang from '../../../components/cabang/LokasiCabang'

export default {
    name: 'edit-cabang',
    components: { LokasiCabang },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            kuLoading: false,
            data: null,
            isLoadingKC: false,
            isLoadingKCS: false,
            kuLoadingFail: false,
            activeSearchKC: null,
            activeSearchKCS: null,
            ku: [],
            staffKC: [],
            staffKCS: [],
            kodeCabangState: null,
            cabang: {},
            input:{
                kodeCabang: null,
                namaCabang: "",
                alamatCabang: "",
                lokasi: { provinsi: null, kota: null, kecamatan: null, kelurahan: null },
				noTelpCabang: null,
				latitude: null,
				longitude: null,
				ipAddress: null,
                kepalaUnit: null,
                skemaPerhitungan: null,
                kepalaCabang: { id: null, name:null },
                kepalaCabangSenior: { id: null, name:null }
            }, 
            skemaOption: [
                {id: 1, name: 'Dibelakang'},
                {id: 2, name: 'Didepan'}
            ],
            kepalaUnit: [],  
            kepalaCabang: [],  
            kepalaCabangSenior: []
        }
    },

    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id
            this.kuLoading = true

            let getSingleCabang = this.$axios.get(`cabang/${this.id}`).then(response => {
                this.cabang = response.data
				console.log(response.data)
                //----------------- Inisialisasi Data Cabang -----------------

                this.input.kodeCabang = this.cabang.kode
                this.input.namaCabang = this.cabang.name
                this.input.alamatCabang = this.cabang.alamat
                // Cabang lama belum punya kecamatan / kelurahan, harus dilengkapi sebelum disimpan
                this.input.lokasi = {
                    provinsi: this.cabang.provinsi,
                    kota: this.cabang.kota && this.cabang.kota.id ? this.cabang.kota : null,
                    kecamatan: this.cabang.kecamatan,
                    kelurahan: this.cabang.kelurahan
                }
				this.input.noTelpCabang = this.cabang.noTelp
				this.input.latitude = this.cabang.latitude
				this.input.longitude = this.cabang.longitude
				this.input.ipAddress = this.cabang.ipAddress
                this.input.skemaPerhitungan = this.cabang.skema.id

                this.$axios.get(`cabang/staffs/${this.id}`).then(response => {
                    this.ku = response.data
                    this.kuLoading = false
                    
                    if(this.cabang.ku != null){
                        this.input.kepalaUnit = this.cabang.ku.id
                    }
                    if(this.cabang.kc != null){
                        this.input.kepalaCabang.id = this.cabang.kc.id
                        this.input.kepalaCabang.name = this.cabang.kc.fullname
                    }
                    if(this.cabang.kcs != null){
                        this.input.kepalaCabangSenior.id = this.cabang.kcs.id
                        this.input.kepalaCabangSenior.name = this.cabang.kcs.fullname
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.kuLoading = false
                    this.kuLoadingFail = true

                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })

            })

            Promise.all([getSingleCabang]).then(() => {
                this.initStatus = 1
                console.log(this.kuLoading)
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Cari Staff -----------------

        loadKU(){
            this.kuLoading = true
            this.kuLoadingFail = false

            this.$axios.get(`cabang/staffs/${this.id}`).then(response => {
                this.ku = response.data
                this.kuLoading = false
                
                if(this.cabang.ku != null){
                    this.input.kepalaUnit = this.cabang.ku.id
                }
                if(this.cabang.kc != null){
                    this.input.kepalaCabang.id = this.cabang.kc.id
                    this.input.kepalaCabang.name = this.cabang.kc.fullname
                }
                if(this.cabang.kcs != null){
                    this.input.kepalaCabangSenior.id = this.cabang.kcs.id
                    this.input.kepalaCabangSenior.name = this.cabang.kcs.fullname
                }
            })
            .catch(error => {
                console.log(error)
                this.kuLoading = false
                this.kuLoadingFail = true

                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        searchKC(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoadingKC = true

                if (this.activeSearchKC == null) this.activeSearchKC = setTimeout(() => { this.searchKCFunc(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearchKC)
                    this.activeSearchKC = setTimeout(() => { this.searchKCFunc(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearchKC)
                this.activeSearchKC = null
                this.isLoadingKC = false
            }
        },

        searchKCFunc(searchQuery){
            this.$axios.get('user/search?fullname='+searchQuery).then(response => {
                this.staffKC = response.data
                this.isLoadingKC = false
                this.activeSearchKC = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        searchKCS(searchQuery){
            if (searchQuery.length >= 4){
                this.isLoadingKCS = true

                if (this.activeSearchKCS == null) this.activeSearchKCS = setTimeout(() => { this.searchKCSFunc(searchQuery) }, 1000)
                else {
                    clearTimeout(this.activeSearchKCS)
                    this.activeSearchKCS = setTimeout(() => { this.searchKCSFunc(searchQuery) }, 1000)
                }
            } 
            else {
                clearTimeout(this.activeSearchKCS)
                this.activeSearchKCS = null
                this.isLoadingKCS = false
            }
        },

        searchKCSFunc(searchQuery){
            this.$axios.get('user/search?fullname='+searchQuery).then(response => {
                this.staffKCS = response.data
                this.isLoadingKCS = false
                this.activeSearchKCS = null
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },
        

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            //----------------- Append Data Cabang -----------------

            payload.append("kode", this.input.kodeCabang)
            payload.append("name", this.input.namaCabang)
            payload.append("alamat", this.input.alamatCabang)
            payload.append("kotaId", this.input.lokasi.kota.id)
            payload.append("kecamatanId", this.input.lokasi.kecamatan.id)
            payload.append("kelurahanId", this.input.lokasi.kelurahan.id)
            payload.append("skemaPerhitungan", this.input.skemaPerhitungan)
            if (this.$helper.isNotNullAndNotEmpty(this.input.noTelpCabang)) payload.append("telepon", this.input.noTelpCabang)
			
			if(this.$helper.isNotNullAndNotEmpty(this.input.latitude)) payload.append("latitude", this.input.latitude)
			if(this.$helper.isNotNullAndNotEmpty(this.input.longitude)) payload.append("longitude", this.input.longitude)
			if(this.$helper.isNotNullAndNotEmpty(this.input.ipAddress)) payload.append("ipAddress", this.input.ipAddress)
			
			
            if(this.input.kepalaUnit != null) payload.append("kuId", this.input.kepalaUnit)
            if(this.input.kepalaCabang.id != null) payload.append("kcId", this.input.kepalaCabang.id)
            if(this.input.kepalaCabangSenior.id != null) payload.append("kcsId", this.input.kepalaCabangSenior.id)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post(`cabang/${this.id}`, payload).then(response => {
                this.initStatus = 1
                this.$helper.setFlash(`Cabang telah berhasil diubah!`)
                
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },


        //----------------- Fungsi Lain -----------------

        onRemoveKU(){
            this.input.kepalaUnit = null
        },

        onRemoveKC(){
            this.input.kepalaCabang = { id: null, name: null }
        },

        onRemoveKCS(){
            this.input.kepalaCabangSenior = { id: null, name: null }
        },

        openModalConfirm(){
            if (!this.validKodeCabang(this.input.kodeCabang) || !(this.input.kodeCabang.length ==4)) {
                this.$helper.toastErr(this, "Kode Cabang harus 4 karakter dan alphanumeric")
                this.kodeCabangState = false;
            } 
            else if (!this.input.lokasi.kota || !this.input.lokasi.kecamatan || !this.input.lokasi.kelurahan) {
                this.$helper.toastErr(this, "Tolong lengkapi provinsi, kota, kecamatan, dan kelurahan cabang")
            }else if(this.$helper.isNullOrEmpty(this.input.kodeCabang) || this.$helper.isNullOrEmpty(this.input.namaCabang) || this.$helper.isNullOrEmpty(this.input.alamatCabang) || this.$helper.isNullOrEmpty(this.input.noTelpCabang)) {
                this.$helper.toastErr(this, "Tolong lengkapi semua data")
            }else if(this.$helper.isNotNullAndNotEmpty(this.input.latitude) && this.input.latitude.length >15){
				this.$helper.toastErr(this, "Latitude maksimal 15 karakter")
			}else if(this.$helper.isNotNullAndNotEmpty(this.input.longitude) && this.input.longitude.length > 15){
				this.$helper.toastErr(this, "Longitude maksimal 15 karakter")
			}else if(this.$helper.isNotNullAndNotEmpty(this.input.ipAddress) && this.input.ipAddress.length> 20){
				this.$helper.toastErr(this, "Alamat IP Cabang maksimal 20 karakter")
			}
            else {
                this.kodeCabangState = true;
                this.$bvModal.show("modal-confirm-edit")
            }
        },

        validKodeCabang(kodeCabang){
            var re = /^[0-9a-zA-Z]+$/;
            return re.test(kodeCabang);
        }

    },

    created(){
        this.init()
    }
}
</script>
